import React from "react"
import { Link } from "react-scroll"
import parse from "html-react-parser"

import { Cta } from "@components/common/cta/Cta"

import * as s from "./CompetitionHeader.module.scss"

export const CompetitionHeader = ({ data, pageContext }) => {
  const {
    headerImage,
    backgroundColour,
    fontColor,
    partnerLogo,
    lockUpImage,
    enterCtaText,
    findOutMoreCtaText,
  } = data

  const { title } = pageContext.page
  let wHeight = 1000

  if (typeof window !== `undefined`) {
    wHeight = window.innerHeight
  }

  return (
    <div
      className={`${s.wrapper} ${
        fontColor === "black" ? s.theme_black : s.theme_white
      } ${findOutMoreCtaText || enterCtaText ? s.wrapper__withLinks : ""}`}
      style={{ backgroundColor: backgroundColour }}
    >
      {partnerLogo && (
        <img
          className={s.partnerLogo}
          src={partnerLogo.sourceUrl}
          alt="Competition Partner"
        />
      )}

      <h1 className={s.title}>{parse(`${title}`)}</h1>
      <div className={s.CtaButtons}>
        <Link to="compForm" spy={true} smooth={true} offset={wHeight * -0.25}>
          <Cta title={enterCtaText} />
        </Link>

        <Link to="compForm" spy={true} smooth={true} offset={wHeight * -0.95}>
          <Cta title={findOutMoreCtaText} />{" "}
        </Link>
      </div>

      {headerImage && (
        <div
          className={s.bannerImage}
          style={{ backgroundImage: `url(${headerImage.sourceUrl})` }}
        >
          {lockUpImage && (
            <img
              className={s.lockupImage}
              src={lockUpImage.sourceUrl}
              alt="Lockup Image"
            />
          )}
        </div>
      )}
    </div>
  )
}
